// Others
import { urlApiVariant } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IQueryParamVariant, IVariant } from '~/utils/interface/variant';

const variantApi = {
  getListVariant: (params: IQueryParamVariant) => {
    const url = urlApiVariant.getListVariant;
    return axiosClient.get<IBaseResponse<IListDataResponse<IVariant[]>>>(url, { params });
  },

  deleteVariant: (id: string) => {
    const url = urlApiVariant.deleteVariant(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default variantApi;
